import { colord as r } from "./index76.mjs";
const o = (t) => t.startsWith("#") ? t : r(t).toHex();
export {
  o as normalizeToHex
};
